"use client";

import { OnboardingEligibilityMessage } from "../OnboardingEligibilityMessage";
import { LinkExchanges } from "@/components/features/wallet/LinkExchanges";
import { ONBOARDING_STEP_TITLES, ONBOARDING_STEP_DESCRIPTIONS } from "@/constants/onboarding";
import { useDevice } from "@/hooks";
import { useLinkCEXStep } from "@/hooks/onboarding";
import { cn } from "@/lib/utils";
import { getScrollbarClasses } from "@/styles/utils/scrollbarStyles.tailwind";
import { Building2 } from "lucide-react";

export const LinkCEXStep = () => {
  const { isMobile } = useDevice();
  const { isStepActive, campaignCountsByExchange, message } = useLinkCEXStep();

  return (
    <div className="flex flex-col w-full h-full gap-4">
      {/* Header */}
      <div className="text-center flex flex-col gap-4">
        <div className="flex items-center justify-center">
          <div className={cn("bg-cede-primary/20 rounded-full flex items-center justify-center", "w-12 h-12")}>
            <Building2 className={cn("text-cede-primary", "w-6 h-6")} />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <h2 className={cn("font-semibold text-cede-text-primary", isMobile ? "text-lg" : "text-xl")}>
            {ONBOARDING_STEP_TITLES.LINK_CEX}
          </h2>
          <p className={cn("text-cede-text-secondary", isMobile ? "text-sm" : "text-base")}>
            {ONBOARDING_STEP_DESCRIPTIONS.LINK_CEX}
          </p>
        </div>
      </div>

      {/* Exchange list - scrollable */}
      <div className="flex-1 overflow-y-auto scrollbar-visible" style={{ minHeight: 0 }}>
        <LinkExchanges
          variant="plain"
          className="bg-transparent p-0"
          innerClassName={cn("overflow-visible pr-0", getScrollbarClasses())}
          showCampaignCounts={true}
          campaignCountsByExchange={campaignCountsByExchange}
          sortByCampaigns={true}
          isStepActive={isStepActive}
        />
      </div>

      {/* CEX connected message or Disclaimer */}
      <OnboardingEligibilityMessage message={message} />
    </div>
  );
};
